import { Container, Grid } from "@mui/material";
import { Stats } from "~/components/DetailsPage/components";
import { spacing } from "~/pages/reports/utils/reportsConstants";
import { ReportsSimpleReportHeader } from "../components";
import { useSecurityReport } from "./hooks/useSecurityReport";
import { AssetReportRiskFactors } from "../AssetReport/components/AssetReportRiskFactors";
import { SecurityReportAssets } from "./components/SecurityReportAssets";
import { ReportsSectionHeading } from "~/pages/reports/components/ReportsSectionHeading";
import { SecurityReportInventoryList } from "~/pages/reports/SecurityReport/components/SecurityReportInventoryList";
import { ReportsGroupSummary } from "~/pages/reports/components/ReportsGroupSummary";

export function SecurityReport() {
  const {
    assets,
    title,
    totalScanned,
    stats,
    groupSummary,
    riskFactorsWithDocs,
    inventoryBreakdown,
  } = useSecurityReport();
  return (
    <Container sx={{ p: 4 }}>
      <Grid container sx={{ mb: spacing[25] }}>
        <ReportsSimpleReportHeader title={title} />
        <Stats id="detail-content-stats" stats={stats} />
        <ReportsGroupSummary groupSummary={groupSummary} />
      </Grid>
      <Grid size={12} sx={{ mb: spacing[25] }}>
        <AssetReportRiskFactors
          dataType="security"
          riskFactors={riskFactorsWithDocs}
        />
      </Grid>
      <Grid size={12} sx={{ mb: spacing[50] }}>
        <ReportsSectionHeading
          heading="Inventory breakdown"
          dividerContent={
            totalScanned ? `${totalScanned} Assets total` : undefined
          }
        />
        <SecurityReportInventoryList softwareEdges={inventoryBreakdown} />
      </Grid>
      <SecurityReportAssets assets={assets} />
    </Container>
  );
}
